<template>
  <div>
    <div>
      <asc-text-field-input
        v-model="dashboardName"
        class="dashboardName"
        :label="'Dashboard Name'"
        :persistent-hint="true"
        :error-messages="dashboardNameErrorMessage"
        :counter="true"
        :max-length="50"
      ></asc-text-field-input>
    </div>
    <div v-if="airlinesData.length > 1" class="asc-empty-div"></div>
    <div>
      <asc-autocomplete-selector
        v-if="airlinesData.length > 1"
        v-model="pbiAirline"
        :items="airlinesData"
        label="Airline"
        class="asc-child-options"
        :on-change="handleAirlineChange"
        placeholder="Select Airline"
        :component-type="'single'"
        dense
        drop-down-size-matches
        fixed-position
      ></asc-autocomplete-selector>
    </div>
    <div class="asc-empty-div"></div>
    <div>
      <asc-autocomplete-selector
        v-model="pbiDataset"
        :items="getDatasetData()"
        label="Dataset"
        class="asc-child-options"
        placeholder="Select Dataset"
        :on-change="handleDatasetChange"
        :component-type="'single'"
        dense
        drop-down-size-matches
        fixed-position
      ></asc-autocomplete-selector>
    </div>
  </div>
</template>

<script>
import AscAutocompleteSelector from './AscAutocompleteSelector.vue'
import AscTextFieldInput from '../atoms/AscTextFieldInput.vue'

export default {
  name: 'AscPowerBiDashboardNameAirlineDatasetChoice',
  components: {
    AscAutocompleteSelector,
    AscTextFieldInput,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    handleUpdate: {
      type: Function,
      default: () => {},
    },
    airlinesData: {
      type: Array,
      default: () => [],
    },
    datasetData: {
      type: Array,
      default: () => [],
    },
    mappedPowerbiAllDatasets: {
      type: Array,
      default: () => [],
    },
    selectedWorkspace: {
      type: Object,
      default: null,
    },
    dashboardNameErrorMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pbiAirline: this.selectedWorkspace ? this.selectedWorkspace.id : null,
      pbiDataset:
        this.value && this.value.pbiDataset && this.value.pbiDataset.value
          ? this.value.pbiDataset.value
          : null,
      selectedItems: null,
    }
  },
  computed: {
    dashboardName: {
      get() {
        return this.value?.dashboardName
      },
      set(val) {
        this.update({
          dashboardName: val,
        })
      },
    },
  },
  methods: {
    getDatasetData() {
      return this.datasetData.length > 0
        ? this.datasetData
        : this.selectedWorkspace
        ? this.mappedPowerbiAllDatasets.filter(
            x => x.pbiWorkspaceId === this.selectedWorkspace.id,
          )
        : null
    },
    update(propToOverwrite) {
      const selectedItems = {
        ...this.value,
        ...propToOverwrite,
      }
      this.emitInput({ ...selectedItems })
    },
    handleAirlineChange(id, selection, selectionObject = []) {
      console.log(selectionObject)
      let val = selectionObject[0] ? selectionObject[0] : {}
      this.pbiDataset = null
      this.update({
        pbiAirline: val,
        pbiDataset: null,
      })
    },
    handleDatasetChange(id, selection, selectionObject = []) {
      let val = selectionObject[0] ? selectionObject[0] : {}
      this.update({
        pbiDataset: val,
      })
    },
    emitInput(data) {
      this.$emit('input', data)
    },
  },
}
</script>
